/**
 * @generated SignedSource<<f685a62ea284a644a1354830adf23d5f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type estimateSimilarSoldTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly ecommerceTrackingParams: any | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "estimateSimilarSoldTracking_item";
};
export type estimateSimilarSoldTracking_item$key = {
  readonly " $data"?: estimateSimilarSoldTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"estimateSimilarSoldTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "estimateSimilarSoldTracking_item"
};

(node as any).hash = "6bde8eab3bc98296cae547ee8fc94a13";

export default node;
